/**
 * @generated SignedSource<<462489b5c36d8891bad570594be2aac9>>
 * @relayHash c93bad48ba71906e46812ba0a92575f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4692bcb06de8760a319f5570010ea9e91ef62772538dd74f6bff1588681fd1d2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4692bcb06de8760a319f5570010ea9e91ef62772538dd74f6bff1588681fd1d2",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
